import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as ErrorCheckmark } from '../../../assets/icons/error-checkmark.svg';
import { ReactComponent as NeutralCheckmark } from '../../../assets/icons/neutral-checkmark.svg';
import { ReactComponent as SuccessCheckmark } from '../../../assets/icons/success-checkmark.svg';

import './PasswordValidation.scss';

interface PasswordValidationProps {
  validation: {
    validLength: boolean;
    hasNumber: boolean;
    upperCase: boolean;
    lowerCase: boolean;
    match?: boolean;
  };
  length: number;
  texts: {
    description: string;
    firstCondition: string;
    secondCondition: string;
    thirdCondition: string;
  };
}

const PasswordValidation = ({ validation, length, texts }: PasswordValidationProps) => {
  const { t } = useTranslation();

  const loadImage = (validationParameter: boolean) => {
    if (length === 0) {
      return <NeutralCheckmark aria-label="Neutral Checkmark" role="presentation" focusable="false" />;
    }
    if (validationParameter) {
      return <SuccessCheckmark aria-label="Success Checkmark" role="presentation" focusable="false" />;
    } else {
      return <ErrorCheckmark aria-label="Error Checkmark" role="presentation" focusable="false" />;
    }
  };

  return (
    <div className="password-validation-container description">
      {t(texts.description)}
      <div className="password-validation-icons">
        <div className="password-validation-row">
          {loadImage(validation.validLength)}
          <div className="password-validation-text">{t(texts.firstCondition)}</div>
        </div>
        <div className="password-validation-row">
          {loadImage(validation.lowerCase && validation.upperCase)}
          <div className="password-validation-text">{t(texts.secondCondition)}</div>
        </div>
        <div className="password-validation-row">
          {loadImage(validation.hasNumber)}
          <div className="password-validation-text">{t(texts.thirdCondition)}</div>
        </div>
      </div>
    </div>
  );
};

export default PasswordValidation;
